function toggleProductGrid(lines) {
    
    const productGrid = document.querySelector('.collection .grid.grid-products');
    
    productGrid.classList.remove('collection__page-products-3');
    productGrid.classList.remove('collection__page-products');
    productGrid.classList.remove('collection__page-products-2');
    productGrid.classList.remove('collection__page-products-1');
    
     if (lines === 2) {
        productGrid.classList.add('collection__page-products-2');
    } else if (lines === 1) {
        productGrid.classList.add('collection__page-products-1');
    }else if (lines === 3) {
        productGrid.classList.add('collection__page-products-3');
    }else if (lines === 4) {
        productGrid.classList.add('collection__page-products');
    }
    const gridButtons = document.querySelectorAll('.st-grid-changer button');
const currentColumns = parseInt(lines); // Assuming 'lines' is the variable containing the current column value

gridButtons.forEach(button => {
    const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
    const isActive = button.classList.contains('active');

    if (buttonColumns === currentColumns && !isActive) {
        button.classList.add('active'); // Add 'active' class
    } else if (buttonColumns !== currentColumns && isActive) {
        button.classList.remove('active'); // Remove 'active' class
    }
});

}

document.addEventListener('DOMContentLoaded', () => {
    // const productGrid = document.querySelector('.product-facet__product-list .product-list__inner');
    const gridButtons = document.querySelectorAll('.st-grid-changer button');
    
    if (window.innerWidth <= 768) { 
        gridButtons.forEach(button => {
            const buttonColumns = parseInt(button.getAttribute('data-grid-layout-columns'));
            if (buttonColumns === 1) {
                button.classList.add('active'); // Add 'active' class to button for collection__page-products-1
            } else {
                button.classList.remove('active'); // Remove 'active' from other buttons
            }
        });
        // productGrid.classList.remove('collection__page-products-1'); // Mobile-specific class removal
    }
    

});